module.exports = __webpack_public_path__ + "d0bc58f54656d7f27c2098dbae1813cc.MP3";